import { useSetAtom } from "jotai";
import { useModals } from "src/components/Modals";
import { merchflowReviewUpdateAtom, type MerchflowReviewUpdateModalData } from "./atoms";

export const useMerchflowReviewUpdateModal = () => {
  const { openModal } = useModals();
  const setUpdateReview = useSetAtom(merchflowReviewUpdateAtom);

  const openMerchflowReviewUpdateModal = (payload: MerchflowReviewUpdateModalData) => {
    setUpdateReview(payload);
    openModal("ModalMerchflowReviewUpdate");
  };

  return { openMerchflowReviewUpdateModal };
};
